import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from '../../services/api.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {StorageService} from '../../services/storage.service';

@Component({
    selector: 'app-modal-termo',
    templateUrl: './modal-termo.component.html',
    styleUrls: ['./modal-termo.component.scss']
})
export class ModalTermoComponent implements OnInit {

    @Input() corPrimaria: string;
    @Input() title: string;
    @Input() text: any;
    @Input() conteudo: any;
    @Input() downloads: any;
    @Input() aplicativo: any;
    @Input() btnText: any;
    @Output() fecharModal = new EventEmitter();
    aceitou = false;
    config: any;

    constructor(private toast: ToastrService,
                private api: ApiService,
                private loading: NgxSpinnerService,
                private storage: StorageService) {
    }

    ngOnInit() {
        //console.log('title: ', this.title);
        //console.log('text: ', this.text);
        //console.log('conteudo: ', this.conteudo);
        //console.log('downloads: ', this.downloads);
        //console.log('aplicativo: ', this.aplicativo);
    }

    fechar(bol) {
        this.fecharModal.emit();
    }

    adicionar() {
      if (this.aceitou == true) {
        this.fecharModal.emit(true);
      } else {
        this.toast.error('Você deve aceitar os termos para continuar.');
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-termo/modal-termo.component.ts